export const buscaAutocomplete = (autocomplete, callback) => {
  if (typeof autocomplete !== 'string') {
    autocomplete = '';
  }
  return callback(autocomplete);
};

export const triggerSelecao = (id) => {
  setTimeout(() => document.getElementById(id).click());
};



// WEBPACK FOOTER //
// ./src/common/functions/autocomplete-utils.js